import * as PIXI from 'pixi.js';
import { BRAND } from '../utils/constants';

export class PreviewNode extends PIXI.Container {
  private graphics: PIXI.Graphics;
  private isValid: boolean = true;

  constructor() {
    super();
    
    this.graphics = new PIXI.Graphics();
    this.addChild(this.graphics);
    
    this.render();
  }

  setPosition(x: number, y: number): void {
    this.x = x;
    this.y = y;
  }

  setValid(valid: boolean): void {
    if (this.isValid !== valid) {
      this.isValid = valid;
      this.render();
    }
  }

  private render(): void {
    this.graphics.clear();
    
    const color = this.isValid ? BRAND.GOLD : BRAND.RED; // Gold if valid, red if invalid
    const alpha = 0.7; // Semi-transparent
    
    // Draw preview node circle
    this.graphics.circle(0, 0, 8);
    this.graphics.fill({ color, alpha });
    this.graphics.stroke({ width: 2, color: 0xffffff, alpha: 0.8 });
    
    // Add pulsing effect for better visibility
    this.graphics.filters = [];
  }

  show(): void {
    this.visible = true;
  }

  hide(): void {
    this.visible = false;
  }
}